import {useFormik} from 'formik';
import React, {FC} from 'react';
import {
    GxButton, 
    GxForm,
    GxIcon,
    GxTextarea,
    GxSelect, 
    GxMenuItem
} from '@garpix/garpix-web-components-react';
import styles from './styles/index.module.scss';
import 'react-responsive-modal/styles.css';
import Input from '../../../../components/Input';
import {MailIcon} from '../../../../assets';
import ModalLayout from '../../../../components/ModalLayout';
import {createResponseTask} from '../../../Tasks/components/helpers';
import {createResponseUser} from '../../helpers';

interface IModalSendMessage {
    flag: boolean;
    onRequestClose: () => void;
    data?: Record<string, any>;
    user?: Record<string, any>
    taskId?: number
}

const ModalSendMessage: FC<IModalSendMessage> = ({flag, onRequestClose, taskId, user}) => {
    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {title: '', type: '1', text: ''},
        onSubmit: (values) => {
          if (taskId) {
            createResponseTask(taskId,{
              title: values.title, text: values.text
            }).then(()=>onRequestClose());
          } else {
            createResponseUser({
              id: user?.id,
              type: Number(values.type),
              data: { title: values.title, body: values.text }
            })
              .then(() => onRequestClose());
          }
        }
    })

    return (
        <div>
            <ModalLayout
                onClose={onRequestClose}
                flag={flag}
            >
                <GxForm onGx-submit={formik.submitForm}>
                    <div className={styles['header']}>
                        <div className={styles['header--container']}>
                            <GxIcon className={styles['header--icon']} src={MailIcon}/>
                            <h2 className={styles['header--title']}>Отправить сообщение</h2>
                        </div>
                        <div className={styles['header--info']}>
                            {user &&
                            <span>{user.first_name ? `Кому:${user.first_name} ${user.last_name}` : `Кому: ${user.username}`}</span>
                            }
                        </div>
                    </div>
                    <div className={styles['main']}>
                        <div className={styles['form']}>
                            <Input
                                label='Тема:'
                                name="title"
                                className={styles['form--item']}
                                value={formik.values.title}
                                handleChange={(e: Record<string, any>) => formik.setFieldValue('title', e.target.value)}
                            />
                            <GxSelect
                                label='Тип:'
                                name='type'
                                className={styles['form--item']}
                                value={formik.values.type}
                                onGx-change={(e: Record<string, any>) => formik.setFieldValue('type', e.target.value)}
                            >
                                <GxMenuItem value='1'>SMS</GxMenuItem>
                                <GxMenuItem value='0'>Email</GxMenuItem>
                            </GxSelect>
                            <GxTextarea
                                resize='none'
                                label='Текст:'
                                name="text"
                                onGx-input={(e: Record<string, any>) => formik.setFieldValue('text', e.target.value)}
                                value={formik.values.text}
                                className={styles['form--item']}/>
                        </div>
                    </div>
                    <div className={styles['footer']}>
                        <GxButton className={styles['footer--btn']} onClick={onRequestClose}>Отмена</GxButton>
                        <GxButton className={styles['footer--btn']} type='submit'>Отправить</GxButton>
                    </div>
                </GxForm>
            </ModalLayout>
        </div>
    );
};

export default ModalSendMessage;